import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import Pagination from "../../components/pageProps/shopPage/Pagination";
import ShopSideNav from "../../components/pageProps/shopPage/ShopSideNav";
import { ShopShimmerUI } from "../../components/ShimmerUI/ShimmerUI";
import useFetch from "../../hooks/useFetch";
import { useTranslation } from "react-i18next";

const Shop = () => {
  const { t } = useTranslation();
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [priceRange, setPriceRange] = useState(null);

  const { data, loading, error } = useFetch("/app/all_products");
  // const { data, loading, error } = useFetch("/app/home");

  useEffect(() => {
    if (data && data.payload) {
      let products = data.payload;

      // Filter by Categories
      if (selectedCategories.length > 0) {
        products = products.filter(product =>
          selectedCategories.includes(product.category.catName)
        );
      }



      // Filter by Price Range
      if (priceRange) {
        products = products.filter(product =>
          product.price >= priceRange.priceOne &&
          product.price <= priceRange.priceTwo
        );
      }

      setFilteredProducts(products);
    }
  }, [data, selectedCategories, selectedBrands, priceRange]);

  const handleCategoryFilter = (categories) => {
    setSelectedCategories(categories);
  };

  const handleBrandFilter = (brands) => {
    setSelectedBrands(brands);
  };

  const handlePriceFilter = (range) => {
    setPriceRange(range);
  };

  // const itemsPerPageFromBanner = (itemsPerPage) => {
  //   setItemsPerPage(itemsPerPage);
  // };

  if (loading) return <ShopShimmerUI />;
  if (error) return <div>Error loading products</div>;
  if (!data || !data.payload) return <div>No products found</div>;

  // Determine which products to display
  const displayProducts = filteredProducts.length > 0 ? filteredProducts : data.payload;

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title={t("shop.products")} />
      <div className="w-full h-full flex pb-20 gap-10">
        <div className="w-[20%] lgl:w-[25%] hidden mdl:inline-flex h-full">
          <ShopSideNav
            data={data.payload}
            onCategoryFilter={handleCategoryFilter}
            onBrandFilter={handleBrandFilter}
            onPriceFilter={handlePriceFilter}
          />
        </div>
        <div className="w-full mdl:w-[80%] lgl:w-[75%] h-full flex flex-col gap-10">
          {/* <ProductBanner itemsPerPageFromBanner={itemsPerPageFromBanner} /> */}

          {priceRange && filteredProducts.length === 0 ? (
            <div className="w-full text-center py-10 bg-gray-100 rounded-lg">
              <h2 className="text-2xl font-semibold text-gray-600">
                Nothing to show
              </h2>
            </div>
          ) : (
            <Pagination
              itemsPerPage={itemsPerPage}
              items={displayProducts}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Shop;